import type {CSSProperties} from 'react';
import {ORPHANED_PREVIEW_HEIGHT_PX, ORPHANED_PREVIEW_WIDTH_PX} from './social-post-content-multiposting.types';

export const getPreviewScaleForDesignWidth = (availablePreviewWidthPx: number, designWidthPx: number): number => {
  return Math.min(1, Math.max(0, availablePreviewWidthPx / designWidthPx));
};

export const getOrphanedPreviewCardStyle = (scale: number): CSSProperties => {
  return {width: `${ORPHANED_PREVIEW_WIDTH_PX}px`, height: `${ORPHANED_PREVIEW_HEIGHT_PX}px`, scale: `${scale}`};
};
